module.exports = __webpack_public_path__ + "assets/img/1.0f487d44.png";